export interface FileIsDirectory {
    readonly type: "file-is-directory";
    readonly path: string;
}
